// extracted by mini-css-extract-plugin
module.exports = {"header":"MobuleMenuItem_header__Lvy4Q","link":"MobuleMenuItem_link__6OaTx"};